import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Link } from "react-router-dom";
import { BlogCard } from "@/components/blog/BlogCard";

interface LocationBlogLinksProps {
  city: string;
}

const LocationBlogLinks = ({ city }: LocationBlogLinksProps) => {
  const { data: posts } = useQuery({
    queryKey: ["location-blog-links"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("blog_posts")
        .select("*")
        .eq("is_published", true)
        .order("published_date", { ascending: false })
        .limit(3);

      if (error) throw error;
      return data;
    },
  });

  if (!posts || posts.length === 0) return null;

  return (
    <section className="py-16 bg-muted/50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-2">
            Cleaning Guides & Tips for {city} Homeowners
          </h2>
          <p className="text-muted-foreground text-center mb-10">
            Maintenance advice and local know-how from our team.
          </p>
          <div className="grid md:grid-cols-3 gap-6">
            {posts.map((post) => (
              <BlogCard
                key={post.id}
                id={post.id}
                title={post.title}
                slug={post.slug}
                excerpt={post.excerpt}
                featuredImage={post.featured_image || undefined}
                publishedDate={post.published_date}
                category={post.category}
              />
            ))}
          </div>
          <div className="text-center mt-8">
            <Link to="/blog" className="text-primary font-semibold hover:underline">
              View All Articles →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationBlogLinks;
